import { createContext, useContext, useState, useEffect } from 'react';
import { authMe, authLogin, authRegister } from '../api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('lawoc_token');
    if (token) {
      authMe()
        .then(r => setUser(r.data.user))
        .catch(() => localStorage.removeItem('lawoc_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const r = await authLogin(email, password);
    localStorage.setItem('lawoc_token', r.data.token);
    setUser(r.data.user);
    return r.data;
  };

  const register = async (name, email, password) => {
    const r = await authRegister(name, email, password);
    localStorage.setItem('lawoc_token', r.data.token);
    setUser(r.data.user);
    return r.data;
  };

  const logout = () => { localStorage.removeItem('lawoc_token'); setUser(null); };

  const isPaid    = () => ['paid','gifted','admin'].includes(user?.role);
  const isAdmin   = () => user?.role === 'admin';
  const isLoggedIn = () => !!user;

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isPaid, isAdmin, isLoggedIn }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
